import {cssTheme} from '@logistics-frontend/blocks'
import {css} from '@logistics-frontend/blocks/theme/css'

export const classes = {
  linkItem: css`
    display: flex;
    width: 100%;
    align-self: stretch;
    text-decoration: none;
  `,
  selected: css`
    background-color: ${cssTheme.colors.amber.high};
  `,
  icon: css`
    transform: rotate(-90deg);
    color: ${cssTheme.default.day.text};
  `,
}
